const useResearcher = () => {
    return {}
}

export default useResearcher
